import React, { useContext } from 'react';

import { CountryCode } from 'js/common/utils/countries';
import { FieldNames } from 'js/auth/types/field';
import { AppEnv } from 'js/project/common/util/segmentAnalytics';

export interface RequestParams {
  appEnv?: AppEnv;
  onPrem?: boolean;
  onPremVersion?: string;
  hasUsers?: boolean;
  authLogoFileName: string;
  showAccountNonCommercialBanner: boolean;
  registrationExtraFields: Array<
    FieldNames.COMPANY | FieldNames.COUNTRY | FieldNames.JOB_RESPONSIBILITY | FieldNames.PHONE_NUMBER
  >;
  registrationDefaultCountry: CountryCode;
  oktaAuthRedirectBase: string;
  oktaBaseUrl: string;
  oktaClientId: string;
  oktaSessionDiscoveryEnabled: boolean;
  baasCentralUrl: string;
  userRegistrationEnabled: boolean;
  userRegistrationDisabledRedirectUrl: string;
  isLdap: boolean;
  siteName: string;
  siteFullName: string;
  atlasSiteName: string;
  atlasSiteFullName: string;
  segmentDefaultUserId: string;
  analyticsEnabled: boolean;
  segmentClientSideWriteKey: string;
  intercomEnabled: boolean;
  intercomAppId: string;
  reCaptchaEnabledLogin: boolean;
  reCaptchaEnabledRegistration: boolean;
  reCaptchaPublic: string;
  isGoogleAuthEnabled: boolean;
  isGithubAuthEnabled: boolean;
  eloquaSiteId?: string;
  centralUrl: string;
  universityCentralUrl: string;
  docsUrl: string;
  multiFactorAuthResetAllowed: boolean;
  multiFactorAuthLevel: string;
  accountMultiFactorAuthEnabled: boolean;
  telecomSvcEnabled: boolean;
  isPersonalApiKeysPageVisible: boolean;
  browserErrorTrackingEnabled: boolean;
  isAccountDeletionEnabled: boolean;
  emailChangeEnabled: boolean;
  accountCentralUrl: string;
  isPersonalizationWizardEnabled: boolean;
  isNdsServerlessEnabled: boolean;
  setupServerlessCreateTestInstanceAllowed: boolean;
  isVercelIntegrationEnabled: boolean;
  atlasClusterWebsocketConnectionBaseUrl: string;
  vercelEmail?: string;
  vercelUserId?: string;
  vercelTeamName?: string;
  vercelTeamId?: string;
}

declare global {
  interface Window {
    REQUEST_PARAMS: RequestParams;
  }
}

const RequestParamsContext = React.createContext(window.REQUEST_PARAMS);

interface RequestParamsProviderProps {
  children: React.ReactNode;
  value?: RequestParams;
}

export const RequestParamsProvider = ({ children, value }: RequestParamsProviderProps) => {
  return (
    <RequestParamsContext.Provider value={value ?? window.REQUEST_PARAMS ?? {}}>
      {children}
    </RequestParamsContext.Provider>
  );
};

export const useRequestParams = () => {
  return useContext(RequestParamsContext);
};
